<template>
  <footer id="footer">
    © 2023-2026 Cyclone RoboSub —
    Web Design by Logan Reuter, Maintained by Jason Pieck
    <!-- —  
    View Website Source on 
  <a href="https://github.com/Cyclone-Robosub/website-source" target="_blank">GitHub</a>   -->
  </footer>
</template>

<script>
export default {
  name: "FooterTile"
}
</script>

<style lang="scss">
a {
  color: var(--white);
  text-decoration: underline;
}

#footer {
  width: 100%;
  font-size: 14px;
  padding: 1.5em;
  color: var(--white);
  background-color: var(--medium);
  position: relative; /* Gives the footer   a positioning context */
}

</style>